<template>
  <div class="landing-page-global about-us-page">
    <div class="nav-bar">
      <div class="nav-bar-content">
        <div class="nav-bar-logo">
          <a href="index.html"><img src="@/assets/landing-page/img/logo-hd.png" alt="simplyBrand" /></a>
        </div>
        <div class="nav-bar-mobile">
          <button type="button" onclick="showmenu()"></button>
          <ul id="menuitems">
            <li><router-link to="/">Home</router-link></li>
            <li><router-link to="/About">About us</router-link></li>
            <li><a href="#requestdemo">Request Demo</a></li>
            <li><router-link to="/CN">中文</router-link></li>
          </ul>
        </div>
        <div class="nav-bar-menu">
          <ul>
            <li><router-link to="/">Home</router-link></li>
            <li class="active-menu"><router-link to="/About">About us</router-link></li>
            <li><router-link to="/Login/Default?lang=en">Login</router-link></li>
          </ul>
        </div>
        <div class="nav-bar-signup">
          <a href="#requestdemo">Request Demo</a><router-link to="/CN">中文</router-link>
        </div>
      </div>
    </div>

    <div class="block-container">
      <div class="our-team">
        <img src="@/assets/landing-page/img/team_pic.png" />
        <div class="our-team-text">
          <h2>Hello! We are simplyBrand.<br>We are on a mission to help brands around the world to grow more efficiently.</h2>
          <h3>We are dedicated to providing data analytics, market insights, e-commerce strategy, and copyright infringement solutions for brands.</h3>
          <p>The team at simplyBrand is formed by specialized professionals with strong backgrounds in Big data, e-commerce, social communities, AI, and legal(IP attorney).</p>
          <p>We are expertise in helping business to craft digital solutions using cloud computing, data security, AI and biotechnology.</p>
        </div>
      </div>
    </div><!-- //.block-container.our-team -->

    <div class="block-container">
      <div id="freetrial" class="freetrial-content" style="background-color: inherit;">
        <div class="freetrial-content-inner">
          <div class="freetrial-content-header">
            <h2>Let's start to grow your business data!</h2>
            <p> simplyBrand offers tailored data solutions that serve your business needs.</p>
          </div>
          <div class="freetrial-content-body">
            <div class="freetrial-content-form">
              <el-form ref="form" :rules="rules" :model="form" >
                <el-row :gutter="50">
                  <el-col :span="12">
                    <el-form-item label="Name">
                      <el-input v-model="form.name"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="Mobile number">
                      <el-input v-model="form.tel"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-form-item label="Company name">
                  <el-input v-model="form.company"></el-input>
                </el-form-item>
                <el-form-item label="E-mail">
                  <el-input v-model="form.email"></el-input>
                </el-form-item>
                <el-form-item>
                  <el-button size="mini" type="primary" @click="sendEmail('form')" :loading="loading">Get My Free Trial</el-button>
                </el-form-item>
              </el-form>
            </div>
          </div>
        </div>
      </div>
    </div><!-- //.block-container.freetrial-content -->

    <div class="site-footer">
      <div class="site-footer-content">
        <div class="site-footer-item site-footer-item-logo">
          <div class="site-footer-item-header">
            <img src="@/assets/landing-page/img/logo-hd.png" alt="simplyBrand" />
          </div>
          <div class="site-footer-body">
            <p>Making it our mission to make brand protection a more transparent, efficient process</p>
          </div>
        </div>
        <div class="site-footer-item site-footer-item-ul">
          <div class="site-footer-item-header">
          </div>
          <div class="site-footer-body">
          </div>
        </div>
        <div class="site-footer-item site-footer-item-contact">
          <div class="site-footer-item-header">
            <h3>Contact</h3>
          </div>
          <div class="site-footer-body">
            <p>contact@simplybrand.com</p>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  data(){
    return{
      loading: false,
      form: {
        name: '',
        from: '',
        tel: '',
        brand: '',
        company: '',
        email: '',
        href: ''
      },
      rules: {
        name: [
          { required: true, message: 'Name', trigger: 'blur' }
        ],
        tel: [
          { required: true, message: 'Mobile No.', trigger: 'blur' },
        ],
      },      
    }
  },

  methods: {
    
    sendEmail: function(formName){
      let that = this
      that.form.from = that.$route.query.ref == undefined ? '非推广来源' : that.$route.query.ref
      that.form.href = window.location.href
      that.$refs[formName].validate((valid) => {
        if (valid) {
          that.loading = true
          // let url = '//similarpic.simplybrand.com/api/userInfo/sendMail'
          let url ='/sendMail'
          $.ajax(url, {
            type: "POST",
            data: that.form,
            success: function(data) {
              console.log(data)
              that.showform = false
              that.loading = false
              that.form = {}
              that.$message({
                showClose: true,
                message: 'Success',
                type: 'success'
              })
            },
            error: function(response) {
              console.log(response)
              that.$message.error('Err')
            }
          })
        } else {
          this.$message.error('Err')
          return false
        }
      })
    },
  }
}
</script>